<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        消防设施
      </div>
    </div>
    <!-- 消防设施开始 -->
    <div>
      <div style="display: flex">
        <h3 class="firehead">建筑消防设施列表</h3>
        <el-button
          type="primary"
          style="height: 30px"
          size="mini"
          @click="opendialog"
          v-hasPermi="['fireFacilities:fireFacilitiesSystem:getFacilities']"
          >配置设施系统</el-button
        >
      </div>

      <div style="display: flex">
        <unitList
          v-show="!($store.state.user.userInfo.natureId == 2)"
          @select="getUnit"
          @getFirst="getOne"
        ></unitList>
        <div class="fireFacilities">
          <div :style="fireList == null ? 'width:0' : 'width:15%'">
            <ul class="firebiao">
              <li
                :class="fireCurrentIndex == index ? 'fireHead1' : 'fireHead'"
                v-for="(item, index) in fireList"
                @click="fireClick(item, index)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="fireCenter"></div>
          <div
            class="fireFightingRight"
            :style="fireList == null ? 'width:90%' : 'width:75%'"
          >
            <div
              class="fireFightingRight_border"
              v-for="(
                item, index
              ) in fireFacilitiesDetailList.fireFacilitiesMiddleList"
            >
              <el-collapse
                accordion
                @change="handleChange(item, index)"
                v-model="activeNames"
              >
                <el-collapse-item :name="index">
                  <template slot="title">
                    <h3 class="monitor_device">
                      {{ item.name || "系统功能" }}
                    </h3>
                    <div class="monitor_count">
                      数量：<span>{{ item.num || 0 }}</span>
                    </div>
                  </template>
                  <div
                    class="fireFightingRight_count"
                    v-for="(item1, index1) in item.fireFacilitiesFunctionList"
                    :key="index1"
                  >
                    <!-- 消防水源表格 -->
                    <div
                      v-if="fireFacilitiesDetailList.systemNum == 12"
                      class="fireFightingRight_count_detail1"
                    >
                      <div class="fireFightingRight_count_detail">
                        <p style="margin: 8px 5px">容积</p>
                        <input
                          class="fireInput"
                          v-model="item1.volume"
                          :placeholder="item1.volume || '暂无'"
                          type="text"
                        />
                      </div>
                      <div class="fireFightingRight_count_detail">
                        <p style="margin: 8px 5px">位置</p>
                        <input
                          class="fireInput"
                          v-model="item1.position"
                          :placeholder="item1.position || '暂无'"
                          type="text"
                        />
                      </div>
                    </div>
                    <!-- 普通表格 -->
                    <div v-else class="fireFightingRight_count_detail1">
                      <div class="fireFightingRight_count_detail">
                        <p style="margin: 8px 5px">品牌、生产厂家</p>
                        <input
                          class="fireInput"
                          v-model="item1.brand"
                          :placeholder="item1.brand || '暂无'"
                          type="text"
                        />
                      </div>
                      <div class="fireFightingRight_count_detail">
                        <p style="margin: 8px 5px">规格型号</p>
                        <input
                          class="fireInput"
                          v-model="item1.specificationsModel"
                          :placeholder="item1.specificationsModel || '暂无'"
                          type="text"
                        />
                      </div>
                      <div class="fireFightingRight_count_detail">
                        <p style="margin: 8px 5px">生产年份</p>
                        <el-date-picker
                          value-format="yyyy-MM-dd HH:mm:ss"
                          v-model="item1.prodDate"
                          type="datetime"
                          class="fireInput"
                          placeholder="选择日期时间"
                        >
                        </el-date-picker>
                      </div>
                    </div>
                    <div
                      class="fireFightingRight_count_detail1"
                      v-if="item1.fireFacilitiesRemarkList"
                    >
                      <div
                        class="fireFightingRight_count_detail"
                        v-for="item2 in item1.fireFacilitiesRemarkList"
                      >
                        <p style="margin: 8px 5px">{{ item2.name }}</p>
                        <input
                          class="fireInput"
                          v-model="item2.value"
                          :placeholder="item2.value || '暂无'"
                          type="text"
                        />
                      </div>
                      <!-- 防烟排烟系统 -->
                      <div
                        v-if="fireFacilitiesDetailList.systemNum == 25"
                        class="fireFightingRight_count_detail"
                      >
                        <p style="margin: 8px 5px">风量</p>
                        <input
                          class="fireInput"
                          v-model="item1.airVolume"
                          :placeholder="item1.airVolume || '暂无'"
                          type="text"
                        />
                      </div>
                      <!--消火栓系统  -->
                      <div
                        v-if="fireFacilitiesDetailList.systemNum === 15"
                        class="fireFightingRight_count_detail"
                      >
                        <p style="margin: 8px 5px">流量(L/S)</p>
                        <input
                          class="fireInput"
                          v-model="item1.flow"
                          :placeholder="item1.flow || '暂无'"
                          type="text"
                        />
                      </div>
                      <div
                        v-if="fireFacilitiesDetailList.systemNum === 15"
                        class="fireFightingRight_count_detail"
                      >
                        <p style="margin: 8px 5px">扬程(m)</p>
                        <input
                          class="fireInput"
                          v-model="item1.lift"
                          :placeholder="item1.lift || '暂无'"
                          type="text"
                        />
                      </div>
                      <!--自动喷水灭火系统  -->
                      <div
                        v-if="fireFacilitiesDetailList.systemNum === 18"
                        class="fireFightingRight_count_detail"
                      >
                        <p style="margin: 8px 5px">流量(L/S)</p>
                        <input
                          class="fireInput"
                          v-model="item1.flow"
                          :placeholder="item1.flow || '暂无'"
                          type="text"
                        />
                      </div>
                      <div
                        v-if="fireFacilitiesDetailList.systemNum === 18"
                        class="fireFightingRight_count_detail"
                      >
                        <p style="margin: 8px 5px">扬程(m)</p>
                        <input
                          class="fireInput"
                          v-model="item1.lift"
                          :placeholder="item1.lift || '暂无'"
                          type="text"
                        />
                      </div>
                    </div>
                    <img
                      src="@/assets/img/fireDelet.png"
                      @click="fireDelete(item1, index1, index)"
                      v-if="item.fireFacilitiesFunctionList.length > 1"
                      class="fireDel"
                      v-hasPermi="[
                        'fireFacilities:fireFacilitiesSystem:saveAndUpdate',
                      ]"
                    />
                  </div>
                </el-collapse-item>
              </el-collapse>
              <!-- <div class="monitor">v-model="activeNames"
            <h3 class="monitor_device">监控设备</h3>
            <div class="monitor_count">数量：<span>2</span></div> 
            
            <img src="@/assets/img/pulldown.png" class="pulldown">
          </div> -->
              <img
                src="@/assets/img/add.png"
                @click="fireAdd(item, index)"
                class="pulldown"
                v-hasPermi="[
                  'fireFacilities:fireFacilitiesSystem:saveAndUpdate',
                ]"
                :style="item.flag ? '' : 'display:none'"
              />
            </div>
            <div class="fireQuestion">
              <h3 class="fireQuestionP">其它问题说明</h3>
              <el-input v-if="fireList == null"  type="textarea"
                placeholder="请输入内容"></el-input>
              <el-input
                v-else
                type="textarea"
                placeholder="请输入内容"
                v-model="fireFacilitiesDetailList.explanation"
              >
              </el-input>
            </div>
            <el-row style="display: flex; justify-content: space-around">
              <el-button type="primary" @click="backtipe = true">返回</el-button>
              <el-button
                type="primary"
                @click="fireSave()"
                v-hasPermi="[
                  'fireFacilities:fireFacilitiesSystem:saveAndUpdate',
                ]"
                >保存</el-button
              >
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <!-- 消防设施结束 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="32%"
      class="dilogMessage"
      :before-close="handleClose"
    >
      <div class="dilogHead">
        <h3 class="headDevice">请选择设施设备</h3>
        <el-input
          class="headInput"
          placeholder="请输入关键字"
          v-model="searchData"
          style="height:30px"
          ><el-button
            slot="append"
            icon="el-icon-search"
            style="height:30px"
            @click="search"
          ></el-button
        ></el-input>
      </div>
      <div class="dilogTotal">
        <div class="dilogLeft">
          <el-scrollbar class="m-scroll" style="height: 100%">
            <!-- <ul> -->
            <div v-for="(item, index) in dilogList" class="dilogDetail">
              <el-checkbox
                :label="item.name"
                v-model="checkList"
                @change="dilogLeftClick(item, index)"
                >{{ item.name }}</el-checkbox
              >
            </div>
            <!-- </ul> -->
          </el-scrollbar>
        </div>
        <div class="dilogRight">
          <el-scrollbar class="m-scroll" style="height: 100%">
            <div class="contentWrap">
              <div
                class="dilogRight_detail"
                v-for="(item, index) in dilogListRight"
              >
                {{ item.name }}
                <i
                  class="el-icon-close closeFire"
                  @click="dilogRightDetailClick(item, index)"
                ></i>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="backtipe = dialogSave()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
  title="提示"
  :visible.sync="backtipe"
  width="30%">
  <h3>这是一段提示信息</h3>
  <p style="width:100%;text-align:center">若需保存信息，请先点击 <span style="color:red;">取消</span></p>
  <p style="width:100%;text-align:center">若需返回上一级页面，请继续点击 <span style="color:red;">返回</span></p>
  <span slot="footer" class="dialog-footer">
    <el-button @click="backtipe = false">取 消</el-button>
    <el-button type="primary" @click="firebBack()">返 回</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script>
import unitList from "@/components/unitList";
export default {
  components: { unitList },

  data() {
    return {
      backtipe:false,
      activeNames: [],
      fireFacilitiesDetailList: { fireFacilitiesMiddleList: 1 },
      pickerValue: "",
      fireCurrentIndex: 0,
      fireList: null,
      cpNum: "",
      dialogVisible: false,
      dilogList: null,
      dilogListRight: null,
      checkList: [],
      searchData: "",
      code: "",
      flag: true,
      // activeNames:[]
    };
  },
  mounted() {
    // 获取消防设施列表
    // this.getFireList();
    // console.log(this.fireFacilitiesDetailList, 2222);
  },
  methods: {
    // 折叠隐藏加号
    handleChange(item, index) {
      console.log(item.flag, "item.flag");
      console.log(item, index);
      console.log(this.activeNames);
      // this.activeNames=['1']
      if (item.flag) {
        console.log("折叠");

        this.fireFacilitiesDetailList.fireFacilitiesMiddleList[
          index
        ].flag = false;
      } else {
        // console.log('展开',this.activeNames.push(String(index)));
        // this.activeNames.push(String(index))
        this.fireFacilitiesDetailList.fireFacilitiesMiddleList.forEach((it) => {
          it.flag = false;
        });
        this.fireFacilitiesDetailList.fireFacilitiesMiddleList[
          index
        ].flag = true;
      }

      // if (val==1) {
      //   console.log('展开');
      // }else{
      //   console.log('折叠额');
      // }
    },
    // 点击减号图标 删掉小项
    fireDelete(item1, index1, index) {


      console.log(item1,index1, index,this.fireFacilitiesDetailList.fireFacilitiesMiddleList[index]);
      // console.log(JSON.parse(JSON.stringify(item)) ,index);
      this.fireFacilitiesDetailList.fireFacilitiesMiddleList[
        index
      ].fireFacilitiesFunctionList.splice(index1, 1);
            // 数量 值
      this.fireFacilitiesDetailList.fireFacilitiesMiddleList[index].num=this.fireFacilitiesDetailList.fireFacilitiesMiddleList[index].fireFacilitiesFunctionList.length

    },
    //点击加号图标 新增窗口
    fireAdd(item, index) {
      console.log(item, index,111111);
      if (this.fireFacilitiesDetailList.fireFacilitiesMiddleList == 1) {
        this.$message({
          message: "暂无表格，无法新增",
          type: "warning",
          duration: 1000,
        });
        return;
      }
    
      let valueCopy = item.fireFacilitiesFunctionList[0];
      this.fireFacilitiesDetailList.fireFacilitiesMiddleList[
        index
      ].fireFacilitiesFunctionList.push(JSON.parse(JSON.stringify(valueCopy)));
      // 把最后一个表格的几个数据清空，不复用前面的值
      let newDataClear =
        this.fireFacilitiesDetailList.fireFacilitiesMiddleList[index]
          .fireFacilitiesFunctionList;
      let newDataClearEnd = newDataClear[newDataClear.length - 1];
      // 普通
      newDataClearEnd.brand = null;
      newDataClearEnd.prodDate = null;
      newDataClearEnd.specificationsModel = null;
      // 消防水源
      newDataClearEnd.volume = null;
      newDataClearEnd.position = null;
      // 防烟排烟系统
      newDataClearEnd.airVolume = null;
      // 消火栓系统 自动喷水灭火系统
      newDataClearEnd.flow = null;
      newDataClearEnd.lift = null;
      // 备注里面
      if (newDataClearEnd.fireFacilitiesRemarkList) {
        for (
          let i = 0;
          i < newDataClearEnd.fireFacilitiesRemarkList.length;
          i++
        ) {
          newDataClearEnd.fireFacilitiesRemarkList[i].value = null;
        }
      }
  // 数量 值
       this.fireFacilitiesDetailList.fireFacilitiesMiddleList[index].num=item.fireFacilitiesFunctionList.length
      console.log(this.numDangle,'numDangle');
      this.$message({
        message: "新增一条表格",
        type: "success",
      });
    },
    //   弹框的搜索框
    search() {
      this.opendialog();
      setTimeout(() => {
        var reg = new RegExp(this.searchData);
        var arr = [];
        for (var i = 0; i < this.dilogList.length; i++) {
          if (reg.test(this.dilogList[i].name)) {
            arr.push(this.dilogList[i]);
          }
        }
        this.dilogList = arr;
      }, 100);
    },
    //   弹窗数据保存
    dialogSave() {
      let remarkArry = this.dilogListRight.map((item, index) => {
        return item.code;
      });
      let remark = remarkArry.join();
      console.log(remark, this.cpNum);
      this.$put("/fireFacilities/fireFacilitiesSystem/updateFacilitiesInfo", {
        remark: remark,
        companyNum: this.cpNum,
      }).then((res) => {
        // console.log(res);
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.getFireList();
      });
      this.dialogVisible = false;
    },
    //  弹窗 右侧--》左侧联动
    dilogRightDetailClick(item, index) {
      console.log(item, index);
      this.dilogListRight.splice(index, 1);
      this.dilogList.forEach((item1, index1) => {
        if (item1.code == item.code) {
          // 让左侧取消勾选
          console.log("让左侧取消勾选");
          this.dilogList[index1].bigItem = null;
          this.checkList.forEach((item2, index2) => {
            // console.log(item2,index2,3333);
            if (item.name == item2) {
              this.checkList.splice(index2, 1);
            }
          });
        }
      });
    },
    //  弹窗 左侧--》右侧联动
    dilogLeftClick(item, index) {
      if (item.bigItem) {
        console.log("you");
        this.dilogListRight.forEach((element, suoyin) => {
          if (item.code == element.code) {
            this.dilogListRight.splice(suoyin, 1);
          }
        });
        this.dilogList[index].bigItem = null;
      } else {
        console.log("meiyou", item);

        this.dilogListRight.unshift(item);
        this.dilogList[index].bigItem = 1;
      }

      //   this.dilogListRight.map((item1,index1)=>{
      //          if (item.code!=item1.code) {
      //           this.dilogListRight.unshift(item)
      //           return item1
      //       }

      //     })
    },
    // 打开弹窗获取弹窗内的数据
    opendialog() {
      this.checkList = [];
      this.dialogVisible = true;
      this.$get(
        "/fireFacilities/fireFacilitiesSystem/getFacilitiesInfo/" + this.cpNum
      ).then((res) => {
        // console.log(res, 111);
        this.dilogList = res.data.allList;
        this.dilogListRight = res.data.existList || [];
        if (res.data.existList) {
          this.checkList = res.data.existList.map(function (item, index) {
            return item.name;
          });
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 点击公司获取报表
    getFireList() {

      this.$get(
        "/fireFacilities/fireFacilitiesSystem/getFacilitiesInfoExist/" +
          this.cpNum
      ).then((res) => {
        this.fireList = res.data;
        // console.log(this.fireList, 111111111111);
        if (this.fireList == null) {
          this.fireFacilitiesDetailList.fireFacilitiesMiddleList = 1;
          return;
        }
        this.fireClick(this.fireList[0], 0);
      });
    },
    // 消防建筑
    fireClick(item, index) {
      this.activeNames = null; //折叠起来，不然加号有问题
      this.code = item.code;
      console.log(item,index,'biaoge');
      this.fireCurrentIndex = index;
      
      // console.log(item, index, this.cpNum, 2222222);
      this.$get(
        "/fireFacilities/fireFacilitiesSystem/getInfo?companyNum=" +
          this.cpNum +
          "&systemNum=" +
          item.code
      ).then((res) => {
        console.log(res.data, 111);
        this.fireFacilitiesDetailList = res.data;
      });
    },
    // 公司id
    getUnit(v) {
      //   console.log(v, 111111111);
      this.cpNum = v;
      this.getFireList();
    },
    getOne(v) {
      //   console.log(v, 222222);

      this.cpNum = v;
      this.getFireList();
    },
    firebBack() {
      
      this.$router.back();
    },
    // 保存
    fireSave() {
      // console.log(this.fireFacilitiesDetailList, 2222);
      if (this.fireFacilitiesDetailList.fireFacilitiesMiddleList == 1) {
        this.$message({
          message: "暂无表格，无法保存",
          type: "warning",
        });
        return;
      }
      this.loading = this.$loading({
        lock: true,
        text: "正在保存",
        background: "rgba(0, 0, 0, 0.7)",
      });

      // 防抖
      if (this.flag) {
        this.flag = false;
        // 折叠的加号图片全部赋值为空
        this.activeNames = null;
        this.fireFacilitiesDetailList.fireFacilitiesMiddleList.forEach(
          (element) => {
            element.flag = false;
          }
        );
        setTimeout(() => {
          this.loading.close();
          this.$post(
            "/fireFacilities/fireFacilitiesSystem",
            this.fireFacilitiesDetailList
          ).then((res) => {
            console.log(res, "保存");
            
            if (res.code == 200) {
              this.fireClick({ code: this.code }, this.fireCurrentIndex);
             
              this.$message({
                message: "保存成功",
                type: "success",
                duration: 1000,
              });
            }
            
          });

          console.log(11111);
          this.flag = true;
        }, 500);
      }
    },
  },
};
</script>
<style scoped>
.dilogHead {
  display: flex;
  /* justify-content: space-around; */
  margin: 0 15px 15px;
}
.headDevice {
  margin-top: 8px;
}
.headInput {
  width: 260px;
  margin-left: 50px;
}
::v-deep .el-select {
  width: 100% !important;
}
.fireFacilities {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.firehead {
  margin: 0 30px 30px 30px;
}
.fireFightingLeft {
  width: 15%;
}
.fireCenter {
  width: 1px;
  height: 100vh;
  border: 1px dashed rgb(172, 172, 172);
}
.fireFightingRight {
  width: 75%;
}
.firebiao {
  margin-left: 30px;
}
.fireHead {
  margin-top: -1px;
  padding: 10px 30px;
  border: 1px solid black;
  margin-bottom: -1px;
  cursor: pointer;
}
.fireHead:hover {
  background-color: rgb(212, 233, 242);
  font-weight: bolder;
}
.fireHead1 {
  margin-top: -1px;
  padding: 10px 30px;
  border: 1px solid black;
  margin-bottom: -1px;
  cursor: pointer;
  background-color: rgb(212, 233, 242);
  font-weight: bolder;
}
::v-deep .el-collapse {
  border: none;
}
::v-deep .el-collapse-item__wrap,
.el-collapse-item__header {
  border: none;
}
::v-deep .el-collapse-item__header {
  border: none;
}
::v-deep .el-collapse-item__header{
  height: 30px;
}
.fireFightingRight_border {
  padding: 3px;
  margin: 3px;
  border: 1px solid rgba(172, 172, 172,0.5);
  border-radius: 10px;
  position: relative;
}
.monitor {
  display: flex;
  /* justify-content: space-between; */
}
.monitor_device {
  width: 40%;
  display: inline-block;
  margin: 7px 0 10px 10px;
}
.monitor_count {
  /* margin-top: 1px; */
}
.fireFightingRight_count {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-width: 100px;
  /* display: grid; */
  /* justify-content: space-between; */
  /* align-content: flex-start; */
  /* align-items: flex-start; */
  /* grid-template-columns: repeat(auto-fill, 1080px); */
  /* grid-gap: 0px 80px; */
  border-bottom: 1px dashed rgb(172, 172, 172);
  padding: 10px 0;
  margin-left: 10px;
}
.fireFightingRight_count_detail1 {
  /* display: flex; */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-width: 100%;
  /* width: calc((100% - 22px) / 3); */
  /* justify-content: space-between; */
}
.fireInput {
  height: 35px;
}
.fireFightingRight_count_detail {
  display: flex;
  margin-bottom: 10px;
  width: calc((100% - 22px) / 3);
}
.pulldown {
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: 0;
  margin-bottom: -2px;
  left: 50%;
  margin-left: -15px;
  cursor: pointer;
  z-index: 3;
}
.dilogMessage {
  /* background-color: #fff; */
  margin-top: 200px;
}
.dilogTotal {
  display: flex;
  /* justify-content: space-around; */
  height: 300px;
  margin: 0 15px 15px;
}

.dilogLeft {
  /* height: 200px; */
  overflow-y: scroll;
}
.dilogRight {
  overflow-y: scroll;
}
.dilogDetail {
  /* text-align: center; */
  margin: 1px;
  width: 300px;
  height: 50px;
  padding: 15px;
  background-color: rgb(231, 242, 252);
}
.contentWrap {
  width: 300px;
  display: flex;
  flex-wrap: wrap;
}
.dilogRight_detail {
  margin: 1px;
  width: 130px;
  /* height: 50px; */
  padding: 5px;
  background-color: rgb(199, 199, 199);
}
.closeFire {
  cursor: pointer;
}
.fireQuestion {
  margin: 10px 15px;
}
.fireQuestionP {
  margin-bottom: 5px;
}
.fireDel {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 100%;
  margin-top: -27px;
  left: 100%;
  /* right: 13%; */
  margin-left: -25px;
  cursor: pointer;
  z-index: 3;
}
</style>